import { render, staticRenderFns } from "./ModalVScrollable.vue?vue&type=template&id=0e041ebc&scoped=true&"
import script from "./ModalVScrollable.vue?vue&type=script&lang=js&"
export * from "./ModalVScrollable.vue?vue&type=script&lang=js&"
import style0 from "./ModalVScrollable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalVScrollable.vue?vue&type=style&index=1&id=0e041ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e041ebc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
